
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class UploadDataService {

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'access-token': environment.prospektr_sell_backend_access_token
    }),
  };
  multiUploadData(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.multiUploadData;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1));
  }

  uploadData(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.uploadData;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1));
  }
  // errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
  //   let errorMessage = '';
  //   if (error.error instanceof ErrorEvent) {
  //     // Get client-side error
  //     errorMessage = error.error.message;
  //   } else {
  //     // Get server-side error
  //     errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  //   }
  //   console.log(errorMessage);
  //   return throwError(() => {
  //     return errorMessage;
  //   });
  // }
}
